/* eslint-disable no-empty-pattern */
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    isInitialLoading: true,
    snapshotIsProcessing: true,
    packageDocs: [],
  },
  getters: {
    activeSubscriptionPlanPackage: (state) => state.packageDocs.find((packageDoc) => packageDoc.fields.type === 'subscriptionPlan'),
  },
  mutations: {
    RESET_STATE(state) {
      state.isInitialLoading = true;
      state.snapshotIsProcessing = true;
      state.packageDocs = [];
    },
    SET_IS_INITIAL_LOADING(state, isInitialLoading) {
      state.isInitialLoading = isInitialLoading;
    },
    SET_SNAPSHOT_IS_PROCESSING(state, snapshotIsProcessing) {
      state.snapshotIsProcessing = snapshotIsProcessing;
    },
    ADD_PACKAGE_DOCS(state, docs) {
      docs.forEach((doc) => {
        state.packageDocs.splice(doc.index, 0, doc.data);
      });
    },
    MOVE_PACKAGE_DOC(state, { oldIndex, newIndex }) {
      // Move index in array
      state.packageDocs.splice(newIndex, 0, state.packageDocs.splice(oldIndex, 1)[0]);
    },
    SET_PACKAGE_DOC_FIELDS(state, { index, fields }) {
      if (!state.packageDocs[index]) return;

      Vue.set(state.packageDocs[index], 'fields', fields);
    },
    REMOVE_PACKAGE_DOC_INDEXES(state, docIndexes) {
      docIndexes.forEach((docIndex) => {
        state.packageDocs.splice(docIndex, 1);
      });
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    updateIsInitialLoading({ commit }, isInitialLoading) {
      commit('SET_IS_INITIAL_LOADING', isInitialLoading);
    },
    async onSnapshot({ state, commit, dispatch }, snapshot) {
      commit('SET_SNAPSHOT_IS_PROCESSING', true);

      const docAdds = [];
      const docIndexesToDelete = [];
      const snapshotChangeTasks = [];

      snapshot.docChanges().forEach((snapshotChanges) => {
        if (snapshotChanges.type === 'added') {
          docAdds.push({
            index: snapshotChanges.newIndex,
            data: {
              id: snapshotChanges.doc.id,
              fields: snapshotChanges.doc.data(),
            },
          });
        } else if (snapshotChanges.type === 'modified') {
          snapshotChangeTasks.push(dispatch('modifyPackageDoc', {
            oldIndex: snapshotChanges.oldIndex,
            newIndex: snapshotChanges.newIndex,
            fields: snapshotChanges.doc.data(),
          }));
        } else if (snapshotChanges.type === 'removed') {
          docIndexesToDelete.push(snapshotChanges.oldIndex);
        }
      });

      if (docAdds.length) {
        snapshotChangeTasks.push(dispatch('addPackageDocs', docAdds));
      }
      if (docIndexesToDelete.length) {
        snapshotChangeTasks.push(dispatch('removePackageDocIndexes', docIndexesToDelete));
      }

      await Promise.all(snapshotChangeTasks);

      commit('SET_SNAPSHOT_IS_PROCESSING', false);

      if (state.isInitialLoading) commit('SET_IS_INITIAL_LOADING', false);
    },
    addPackageDocs({ commit }, docs) {
      commit('ADD_PACKAGE_DOCS', docs);
    },
    modifyPackageDoc({ commit }, { oldIndex, newIndex, fields }) {
      if (oldIndex !== newIndex) commit('MOVE_PACKAGE_DOC', { oldIndex, newIndex });

      commit('SET_PACKAGE_DOC_FIELDS', { index: newIndex, fields });
    },
    removePackageDocIndexes({ commit }, docIndexes) {
      commit('REMOVE_PACKAGE_DOC_INDEXES', docIndexes);
    },
  },
};
